import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var testRoute = [{
  path: "/test",
  name: "test",
  component: function component() {
    return import("./test.vue");
  }
}];